import { render, staticRenderFns } from "./WatchdogTable.vue?vue&type=template&id=3132dd8c&"
import script from "./WatchdogTable.vue?vue&type=script&lang=js&"
export * from "./WatchdogTable.vue?vue&type=script&lang=js&"
import style0 from "./WatchdogTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports